import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/beranda/Hero';
import Why from '../components/beranda/Why';
import Onboarding from '../components/beranda/Onboarding';
import Promosi from '../components/beranda/Promosi';
import Signup from '../components/beranda/Signup';
import Curriculum from '../components/beranda/Curriculum';
import Testimonials from '../components/beranda/Testimonials';

const Main = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return undefined;
    }

    const targetId = decodeURIComponent(hash.replace('#', ''));
    const targetElement = document.getElementById(targetId);

    if (!targetElement) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);

    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="min-h-screen">
      <Hero />
      <Why />
      <Onboarding />
      <Promosi />
      <Curriculum />
      <Testimonials />
      <Signup />
    </div>
  );
};

export default Main;